import stripePaymentIntentForm from "../../shared/stripePaymentIntentForm";

export default (locale) => {
  stripePaymentIntentForm(locale);
};
